import { AssetDirectoryStore } from './asset-directory.store';
import { Injectable } from '@angular/core';
import { BaseQuery } from "../base/base.query";

@Injectable({ providedIn: 'root' })
export class AssetDirectoryQuery extends BaseQuery {

    constructor(store: AssetDirectoryStore) {
        super(store);
    }
}
